module.exports = __webpack_public_path__ + "static/media/edit.4665920a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/edit.svg
// module id = 1049
// module chunks = 3